const SESSION_STORAGE_KEY = 'meteris_session_token';
const LEGACY_STORAGE_KEYS = ['admin_session_token'];

function getStorage() {
  if (typeof window === 'undefined') return null;
  return window.localStorage;
}

export function getStoredSessionToken() {
  const storage = getStorage();
  if (!storage) return '';

  const primaryToken = storage.getItem(SESSION_STORAGE_KEY);
  if (primaryToken) return primaryToken;

  for (const key of LEGACY_STORAGE_KEYS) {
    const legacyToken = storage.getItem(key);
    if (legacyToken) {
      storage.setItem(SESSION_STORAGE_KEY, legacyToken);
      return legacyToken;
    }
  }

  return '';
}

export function storeSessionToken(token) {
  const storage = getStorage();
  if (!storage || !token) return;

  storage.setItem(SESSION_STORAGE_KEY, token);
  for (const key of LEGACY_STORAGE_KEYS) {
    storage.setItem(key, token);
  }
}

export function clearStoredSessionToken() {
  const storage = getStorage();
  if (!storage) return;

  storage.removeItem(SESSION_STORAGE_KEY);
  for (const key of LEGACY_STORAGE_KEYS) {
    storage.removeItem(key);
  }
}
